import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard, A11y } from 'swiper';
import useMediaQuery from '../custom-hooks/useMediaQuery';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';
import { device } from '../../utils/styled-component-mixins';
import 'swiper/css';
import 'swiper/css/pagination';
import CardSwiperWrapperStyled from './styled-components/CardSwiperWrapperStyled';
import ContentCard from './cards/ContentCard';

const TrendingTopicsCarouselWrapperStyled = styled.div`
  .content-card-wrapper {
    height: 100%;
  }

  .card-slider {
    .swiper {
      margin-top: 0;
    }
  }

  .swiper-padding {
    padding: 0;
  }

  .content-card {
    display: flex;
    flex-direction: column;
    height: 100%;

    @media ${device.desktop} {
      flex-direction: row;
    }
    .content-wrapper {
      display: flex;

      .animated-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between !important;

        .text-wrapper {
          flex: 1;
        }

        h3 {
          font-size: 2.2rem;
          line-height: 3.2rem;

          @media ${device.desktop} {
            font-size: 3rem;
            line-height: 4rem;
          }
        }

        p {
          @media ${device.desktop} {
            font-size: 1.6rem;
          }
          display: block;
        }
      }
    }

    @media ${device.desktop} {
      .featured-card-image,
      .featured-card-content {
        flex-basis: 50% !important;
      }
    }

    .featured-card-content {
      flex: 1;

      @media ${device.desktop} {
        padding: 5rem 5rem 0 5rem !important;
      }

      @media ${device.desktopLg} {
        padding: 7.5rem 10rem 0 10rem !important;
      }
    }

    .featured-card-image {
      padding-bottom: min(24rem, calc(100% * (5 / 6))) !important;
    }

    .animation-wrapper,
    .content-wrapper,
    .animated-content {
      height: 100%;
    }

    .content-wrapper {
      @media ${device.desktop} {
        height: 85%;
      }
    }

    @media ${device.desktop} {
      height: 40rem;
    }
  }

  .swiper {
    @media ${device.desktop} {
      padding: 9rem 17.5rem;
    }

    .swiper-button-prev {
      @media ${device.desktop} {
        left: 8.5rem;
      }
    }

    .swiper-button-next {
      @media ${device.desktop} {
        right: 8.5rem;
      }
    }
  }

  .swiper-slide {
    @media ${device.desktop} {
      max-width: 100%;
      min-width: 100%;
      width: 100%;
    }
  }
`;

const TrendingTopicsCarouselComponent = (props) => {
  const isDesktop = useMediaQuery(device.desktop);
  const cardProps = { layout: 'wide-horizontal-short', mediaSide: 'left' };

  return (
    <WidgetIdWrapper widgetID={props.widgetId}>
      <TrendingTopicsCarouselWrapperStyled>
        <CardSwiperWrapperStyled className="container-padding-md swiper-padding">
          <div className="card-slider">
            <Swiper
              pagination={{ clickable: { isDesktop } }}
              modules={[Pagination, Navigation, Keyboard, A11y]}
              a11y={true}
              navigation={true}
              keyboard={true}
              slidesPerGroup={1}
              initialSlide={0}
              breakpoints={{
                320: {
                  slidesPerView: 'auto',
                  spaceBetween: 16,
                  centeredSlides: true
                },
                992: {
                  slidesPerView: 1,
                  spaceBetween: 500,
                  centeredSlides: false
                }
              }}
            >
              {props.items.length > 0 &&
                props.items.map((item) => (
                  <SwiperSlide key={item.pageTitle} className="swiper-slide-wrapper">
                    <ContentCard cardProps={cardProps} item={item} />
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        </CardSwiperWrapperStyled>
      </TrendingTopicsCarouselWrapperStyled>
    </WidgetIdWrapper>
  );
};

export default withWidgetSpacingWrapper(TrendingTopicsCarouselComponent);
